import type { IconAliases } from "vuetify";
import {
  ArrowRight,
  Users,
  UsersRound,
  ClipboardList,
  MailCheck,
  Banknote,
  FileUp,
  BarChart3,
  Gauge,
} from "lucide-vue-next";

export const icons: Partial<IconAliases> = {
  arrowRight: ArrowRight,
  users: Users,
  usersRound: UsersRound,
  clipboardList: ClipboardList,
  mailCheck: MailCheck,
  banknote: Banknote,
  fileUp: FileUp,
  barChart: BarChart3,
  gauge: Gauge,
} as unknown as Partial<IconAliases>;
